const module = {
  namespaced: true,
  state: () => ({
    visuals: [],
    visualBanners: [],
    tags: {},
    themeProducts: [],
    recentlyViewedProducts: [],
    recommendProducts: {},
    lastMinuteDeals: [],
    bestDeals: [],
    recommendedTheme: {},
    magazines: [],
    eventBanners: [],
    itineraries: [],
    youMayLikes: [],
    platformInfo: {},
  }),
  getters: {
    visuals: (state) => state.visuals,
    tags: (state) => state.tags,
    themeProducts: (state) => state.themeProducts,
    recentlyViewedProducts: (state) => state.recentlyViewedProducts,
    recommendProducts: (state) => state.recommendProducts,
    lastMinuteDeals: (state) => state.lastMinuteDeals,
    bestDeals: (state) => state.bestDeals,
    recommendedTheme: (state) => state.recommendedTheme,
    magazines: (state) => state.magazines,
    eventBanners: (state) => state.eventBanners,
    itineraries: (state) => state.itineraries,
    youMayLikes: (state) => state.youMayLikes,
    platformInfo: (state) => state.platformInfo,
  },
  actions: {
    async getVisuals({ commit }) {
      try {
        const { data } = await this.$http.get('/contents/v1/visual/main')
        await commit('setVisuals', data)
      } catch (err) {
        console.log(err)
      }
    },

    async getVisualBanners({ commit }) {
      try {
        const { data } = await this.$http.get('/contents/v1/banner/global-top')
        await commit('setVisualBanners', data)
      } catch (err) {
        console.log(err)
      }
    },

    async getTags({ commit, dispatch }) {
      try {
        const response = await this.$http.get('/contents/v1/tags/theme')
        commit('setTags', response.data)
        await dispatch('getThemeProducts', {
          limit: 12,
          tags: [response.data.with[0], response.data.theme[0]],
        })
      } catch (err) {
        console.log(err)
      }
    },

    async getThemeProducts({ commit }, body) {
      try {
        const { data } = await this.$http.post('/product/v1/tag/theme', body)
        await commit('setThemeProducts', data)
      } catch (err) {
        console.log(err)
      }
    },

    async getRecentlyViewedProducts({ commit, rootState: state }) {
      if (!state.auth.isLogged) return
      try {
        const { data } = await this.$http.get('/product/v1/me/watching')
        await commit('setRecentlyViewedProducts', data)
      } catch (err) {
        console.log(err)
      }
    },

    async getRecommendProducts({ commit }) {
      try {
        const { data } = await this.$http.get('/contents/v1/city-recommend')
        await commit('setRecommendProducts', data)
      } catch (err) {
        console.log(err)
      }
    },

    async getLastMinuteDeals({ commit }) {
      try {
        const { data } = await this.$http.post('/product/v1/deal/last')
        await commit('setLastMinuteDeals', data)
      } catch (err) {
        console.log(err)
      }
    },

    async getBestDeals({ commit }) {
      try {
        const { data } = await this.$http.get('/product/v1/deal/weekly')
        await commit('setBestDeals', data)
      } catch (err) {
        console.log(err)
      }
    },

    async getRecommendedTheme({ commit }) {
      try {
        const { data } = await this.$http.get('/contents/v1/theme/recommend')
        await commit('setRecommendedTheme', data)
      } catch (err) {
        console.log(err)
      }
    },

    async getEventBanners({ commit }, { params }) {
      try {
        const { data } = await this.$http.get('/contents/v1/visual/promotion', { params })
        await commit('setEventBanners', data)
      } catch (err) {
        console.log(err)
      }
    },

    async getMagazines({ commit }, { params }) {
      try {
        const { data } = await this.$http.get('/contents/v1/magazine/pick', { params })
        await commit('setMagazines', data)
      } catch (err) {
        console.log(err)
      }
    },

    async getItineraries({ commit }, { params }) {
      try {
        const { data } = await this.$http.get('/trip/v1/popular-pick', { params })
        await commit('setItineraries', data)
      } catch (err) {
        console.log(err)
      }
    },

    async getYouMayLikes({ commit, rootState: state }) {
      if (!state.auth.isLogged) return
      try {
        const { data } = await this.$http.get('/order/v1/me/products/recommend')
        await commit('setYouMayLikes', data)
      } catch (err) {
        console.log(err)
      }
    },

    async getPlatFormInfo({ commit }) {
      try {
        const { data } = await this.$http.get('/platform/v1/overview')
        await commit('setPlatFormInfo', data)
      } catch (err) {
        console.log(err)
      }
    },
  },
  mutations: {
    setVisuals(state, visuals) {
      state.visuals = visuals
    },
    setVisualBanners(state, banners) {
      state.visualBanners = banners
    },
    setTags(state, tags) {
      state.tags = tags
    },
    setThemeProducts(state, products) {
      state.themeProducts = products
    },
    setRecentlyViewedProducts(state, products) {
      state.recentlyViewedProducts = products
    },
    setRecommendProducts(state, products) {
      state.recommendProducts = products
    },
    setLastMinuteDeals(state, products) {
      state.lastMinuteDeals = products
    },
    setBestDeals(state, data) {
      state.bestDeals = data
    },
    setRecommendedTheme(state, theme) {
      state.recommendedTheme = theme
    },
    setEventBanners(state, banners) {
      state.eventBanners = banners
    },
    setMagazines(state, magazines) {
      state.magazines = magazines
    },
    setItineraries(state, itineraries) {
      state.itineraries = itineraries
    },
    setYouMayLikes(state, products) {
      state.youMayLikes = products
    },
    setPlatFormInfo(state, data) {
      state.platformInfo = data
    },
  },
}

export default module
